import { getSafeExternalUrl } from "./security";

const SOCIAL_CONFIG = {
  youtube: {
    domains: ["youtube.com", "youtu.be"],
    host: "www.youtube.com",
    profilePrefix: "@",
  },
  tiktok: {
    domains: ["tiktok.com"],
    host: "www.tiktok.com",
    profilePrefix: "@",
  },
  twitch: {
    domains: ["twitch.tv"],
    host: "www.twitch.tv",
    profilePrefix: "",
  },
  instagram: {
    domains: ["instagram.com"],
    host: "www.instagram.com",
    profilePrefix: "",
  },
  twitter: {
    domains: ["x.com", "twitter.com"],
    host: "x.com",
    profilePrefix: "",
  },
};

function stripProtocol(value) {
  return value.replace(/^(?:https?:)?\/\//i, "").replace(/^www\./i, "");
}

function stripRepeatedDomain(value, domains) {
  let remainder = value;
  let matchedDomain = "";

  for (const domain of domains) {
    const domainIndex = remainder.toLowerCase().indexOf(domain);
    if (domainIndex !== -1) {
      remainder = remainder.slice(domainIndex);
      matchedDomain = domain;
      break;
    }
  }

  if (!matchedDomain) return null;

  const escapedDomain = matchedDomain.replaceAll(".", "\\.");
  const leadingDomain = new RegExp(`^(?:www\\.)?${escapedDomain}\/?`, "i");

  while (leadingDomain.test(remainder)) {
    remainder = remainder.replace(leadingDomain, "");
  }

  return { domain: matchedDomain, path: remainder.replace(/^\/+/, "") };
}

export function normalizeSocialUrl(platform, value) {
  if (typeof value !== "string") return "";

  const trimmed = value.trim();
  if (!trimmed) return "";
  if (/^(?:javascript|data|vbscript):/i.test(trimmed)) return "";

  const config = SOCIAL_CONFIG[platform];
  if (!config) {
    const candidate = /^(?:https?:)?\/\//i.test(trimmed)
      ? trimmed.replace(/^\/\//, "https://")
      : `https://${trimmed}`;
    return getSafeExternalUrl(candidate);
  }

  const withoutProtocol = stripProtocol(trimmed);
  const domainMatch = stripRepeatedDomain(withoutProtocol, config.domains);

  if (domainMatch) {
    const host = domainMatch.domain === "youtu.be" ? "youtu.be" : config.host;
    const normalizedPath = config.profilePrefix
      ? domainMatch.path
      : domainMatch.path.replace(/^@/, "");
    return `https://${host}${normalizedPath ? `/${normalizedPath}` : ""}`;
  }

  if (/^(?:https?:)?\/\//i.test(trimmed)) {
    return "";
  }

  const handle = withoutProtocol.replace(/^@/, "").replace(/^\/+|\/+$/g, "");
  if (!handle) return "";

  return getSafeExternalUrl(`https://${config.host}/${config.profilePrefix}${handle}`);
}
